<template>
  <div class="script-agent">
    <section class="script-agent__section" v-if="sectionCount == 0">
      <h1 class="script-agent__title">Section 1: Intro</h1>
      <br />
      <div class="script-agent__question">
        Hi <b>{{ lead.fullname }}</b
        >, This is <b>{{ lead.agent_fullname }}</b> with Blueberry insurance on
        a recorded line. How are you doing today?
        <span class="red--text">(Get response)</span>.
      </div>
      <br />
      <div class="script-agent__question">
        Great! Now before we get started, let me share with you a little bit about who I am, what these state regulated plans are, how you can apply for them, and then you can tell me what to do from there.  Go ahead and grab yourself a pen and paper and let me know when you’re ready.
        <span class="red--text">(Pause for Response)</span>.
      </div>
      <br />
      <div class="script-agent__question">
        Now, <b>{{ lead.fullname }}</b>, I am an independent agent with Blueberry insurance, and what that means <b>{{ lead.fullname }}</b>, is that I represent YOU, not any particular company or organization.  I work with OVER a dozen different carriers, like Mutual of Omaha, AIG, and Foresters, just to name a few.  The best part, <b>{{ lead.fullname }}</b> is that ALL of these carriers carry an A rating, which means there are no other companies out there better suited to protect your family, ok?
        <span class="red--text">(Get Response)</span>
      </div>
      <br />

      <div class="script-agent__question">
        These plans are affordable, whole life insurance policies that are regulated by the state of <span class="red--text">(State Client is Physically Present)</span>, and are typically designed for folks who are living on a fixed or a limited income, such as social security or disability.  One of the best parts about these plans is that your premiums will never increase and your benefits will ALWAYS stay the same.
      </div>

      <div class="script-agent__question">
        These plans are meant to cover your funeral and burial expenses, and if you qualify, they pay out 100% to your beneficiaries, usually within a week of your passing. So this may be the first MONEY your family will see at that time.
      </div>

      <div class="script-agent__question">
        Now, <b>{{ lead.fullname }}</b>, all I  have to do is ask you a few simple questions so that we can find the BEST plans for you and your family, and then I can go ahead and give you the exact price, right here over the phone.
      </div>
    </section>
    <section class="script-agent__section" v-else-if="sectionCount == 1">
      <h1 class="script-agent__title">Section 2: Needs</h1>

      <div class="script-agent__question">
        Do you currently have any Final expense or life insurance in place currently?
      </div>

      <div class="script-agent__question">
        <span class="red--text">(If Yes)</span>
      </div>

      <div class="script-agent__question">
        That’s great, how much coverage do you have?
        <span class="red--text">(Get Response)</span>
      </div>

      <div class="script-agent__question">
        How long have you had this coverage?
        <span class="red--text">(Get Response)</span>
      </div>

      <div class="script-agent__question">
        And what company is that with?
        <span class="red--text">(Get Response)</span>.
      </div>

      <div class="script-agent__question">
        Well, let me commend you for putting that coverage in place, obviously this is something that is very important to you.  A lot of the folks that I talk to everyday also have some type of coverage in place, but very rarely do they ever have enough, or even the right type of coverage to ensure that their loved ones are fully protected, so we are going to do EVERYTHING we can to see if we can get you qualified for one of these state regulated plans today, OK?
        <span class="red--text">(Get Response)</span>.
      </div>

      <div class="script-agent__question">
        <span class="red--text">(If No)</span>
      </div>

      <div class="script-agent__question">
        That’s ok, <b>{{ lead.fullname }}</b> I’m really glad we’re talking today.  Have you had coverage at any point in the past?
        <span class="red--text">(Get Response)</span>
      </div>

      <div class="script-agent__question">
        <span class="red--text">(If Yes)</span>
      </div>

      <div class="script-agent__question">What happened?</div>

      <div class="script-agent__question">
        <span class="red--text">(If No)</span>
      </div>

      <div class="script-agent__question">
        That’s ok. I talk to folks every day just like yourself who really need this coverage but haven’t yet been presented with one of these special state regulated plans, so I’m going to do everything I can to get you qualified here today, ok?
        <span class="red--text">(Get Response)</span>.
      </div>

      <div class="script-agent__question">
        (Client Name) one of the most common needs that we see, is that people simply want to make sure that when their time comes, they’re not leaving a big financial burden behind for their loved ones to deal with, is that how you feel?
        <span class="red--text">(Pause for Response)</span>.
      </div>

      <div class="script-agent__question">
        Have you thought about what kind of sendoff you want for yourself...traditional burial or cremation?
        <span class="red--text">(Get Response)</span>
      </div>

      <div class="script-agent__question">
        Any reason why you are leaning towards ______?
        <span class="red--text">(Get Response)</span>
      </div>

      <div class="script-agent__question">
        Well, regardless of whether you go with a traditional burial or cremation, it’s still expensive, and with you having <span class="red--text">(No Coverage/Amount of Coverage)</span>, we know there are going to be expenses left to your family.  When you take into consideration ALL the expenses at the end of your life, how much do you think it will cost them?
        <span class="red--text">(Get Response)</span>
      </div>

      <div class="script-agent__question">
        So with what the cost of your sendoff will be, along with other typical end of life expenses, it looks like you’ll really need <span class="red--text">(Amount of coverage/Additional coverage)</span>, otherwise, you’ll be leaving a tremendous financial burden on your family, and I KNOW the reason we are talking today is because you DON’T want that, right?
        <span class="red--text">(Get Response)</span>
      </div>

      <div class="script-agent__question">
        So, who would you be leaving this money behind to?
        <span class="red--text">(Get Response)</span>
      </div>

      <div class="script-agent__question">
        Wow, that’s a really wonderful and loving thing for you to do, it really shows what a huge heart you have!  Not only that, but you’ll have the peace of mind knowing that <b>{{ getNameFromBeneficiaries() }}</b> won’t be burdened with the tremendous cost of your final expenses.
      </div>
    </section>
    <section class="script-agent__section" v-else-if="sectionCount == 2">
      <h1 class="script-agent__title">Section 3: Underwriting</h1>
      <br />

      <div class="script-agent__question">
        Now, as I’m sure you’re aware, insurance is based on two things: your age and your health, so in order for me to find the BEST plan to fit your needs, I’m going to ask you a few simple health questions to see what plans you MAY qualify for.
      </div>

      <div class="script-agent__question">What is your Date of Birth?</div>

      <div class="script-agent__question">What is your Height and Weight?</div>

      <div class="script-agent__question">
        Have you used ANY tobacco or nicotine products in the past 12 months?
        <span class="red--text">(This includes marijuana)</span>
      </div>

      <div class="script-agent__question">
        Do you have Diabetes or Neuropathy?
      </div>

      <div class="script-agent__question">
        <span class="red--text">(If Yes)</span>
      </div>

      <div class="script-agent__question">
        Do you take insulin or oral medication?
      </div>

      <div class="script-agent__question">
        Do you use any oxygen to assist in breathing or require any assistance with activities of daily living?
      </div>

      <div class="script-agent__question">
        Do you have any breathing disorders such as COPD, emphysema, or chronic bronchitis?
      </div>

      <div class="script-agent__question">
        Have you ever been treated or diagnosed for any type of cardiac issues, stroke, mini stroke, or any other type of heart, brain, or circulatory surgery?
      </div>

      <div class="script-agent__question">
        Have you been treated or diagnosed with either high blood pressure or high cholesterol?
      </div>

      <div class="script-agent__question">
        Do you take any medication for pain?
      </div>

      <div class="script-agent__question">
        Do you currently have any form of cancer, or have you had cancer at any time in the past?
      </div>

      <div class="script-agent__question">
        Do you take any medication for anxiety or depression?
      </div>

      <div class="script-agent__question">
        Have you had any other major medical issues that I may have missed, or any other surgeries that we haven’t yet discussed?
      </div>

      <div class="script-agent__question">
        What medications are you currently prescribed?
        <span class="red--text">(Doesn’t matter if currently taking or not)</span>
      </div>

      <div class="script-agent__question">
        Thank you for your honesty, it helps ensure that I find the BEST plan that meets your needs. However, there are some concerns here that may cause a red flag with the insurance company, like <span class="red--text">(share age/health concerns)</span>.  Now I can’t make any promises, but I’m going to do whatever I can to try and get you qualified here TODAY, ok?
        <span class="red--text">(Get Response)</span>
      </div>

      <div class="script-agent__question">
        <span class="red--text">(Pause a good few seconds here.  Let the anticipation build and then really bring the enthusiasm when giving the quote)</span>
      </div>
    </section>
    <section class="script-agent__section" v-else-if="sectionCount == 3">
      <h1 class="script-agent__title">Section 4: Quote</h1>
      <br />
      <div class="script-agent__question">
        Now, <b>{{ lead.fullname }}</b>, I’m looking over these options, and I’ve got to congratulate you!  It looks as though you MAY be eligible to qualify for one of our premiere plans, this is absolutely incredible!
      </div>

      <div class="script-agent__question">
        The name of the company that I recommend for you is [Company Name], and they [Company talking points].
      </div>

      <div class="script-agent__question">
        Do you still have your pen and paper handy?
        <span class="red--text">(Get Response)</span>
      </div>

      <div class="script-agent__question">
        Great! I’m going to share 3 affordable options with you, and again, <b>{{ lead.fullname }}</b> a lot of folks your age dont even qualify for rates like these.
      </div>

      <div class="script-agent__question">
        The first option you’ve qualified for is <span class="red--text">(Coverage Amount 1)</span>.  And that premium is ONLY <span class="red--text">($ per month)</span>.  You get that?
      </div>
      <div class="script-agent__question">
        Ok, perfect.  The second option you qualified for is <span class="red--text">(Coverage Amount 2)</span>.  And that premium is ONLY <span class="red--text">($ per month)</span>.
      </div>

      <div class="script-agent__question">
        And the third option you qualify for is <span class="red--text">(Coverage Amount 3)</span>. And that premium is ONLY <span class="red--text">($ per month)</span>.
      </div>
    </section>
    <section class="script-agent__section" v-else-if="sectionCount == 4">
      <h1 class="script-agent__title">Section 5: The Close</h1>
      <div class="script-agent__question">
        So, TELL ME, <b>{{ lead.fullname }}</b> ...Which option would you want for <b>{{ getNameFromBeneficiaries() }}</b> to receive when that day comes, a check for <span class="red--text">(Coverage Amount 1)</span>, a check for <span class="red--text">(Coverage Amount 2)</span>, or a check for <span class="red--text">(Coverage Amount 3)</span>?
      </div>
      <div class="script-agent__question">
        Excellent Choice!  That’s the amount A LOT of people have been picking for their families.
      </div>

      <span class="red--text">(If Hesitation)</span>

      <div class="script-agent__question">
        That’s ok, remember, you aren’t paying for ANYTHING today, so what we can do to make this REALLY simple for you is let’s take the LOWEST option since that is the most affordable one.  This will address your biggest concern of making sure you have <b>${{lead.coverage_amount}}</b> in place for your family and take this financial burden off their shoulders.  Now, if at ANY time you want to add more coverage or make ANY type of changes, I will ALWAYS be here to help you with that, but the last thing we would want to see happen is that you get sick or hurt or even worse die without this coverage in place.  So let’s go with that lowest option
      </div>

      <div class="script-agent__question">
        What’s your middle initial?
      </div>

      <span class="red--text">(Move to Application)</span>

      <span class="red--text">(After Application Before YOu Hang Up With Client)</span>

      <h1 class="script-agent__title">Cooldown</h1>

      <div class="script-agent__question">
        I’m so glad we were able to put this coverage in place and protect your loved ones, <b>{{ lead.fullname }}</b>.  But tell me, what made you take action and finally do it today? (Pause for Response)
        <span class="red--text">(Pause for Response)</span>
      </div>

    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ScriptFex",
  props: {
    lead: Object,
    baseData: Object,
    sectionCount: Number,
  },
  data() {
    return {
      dialog: false,
      questionCount: 0,
    };
  },
  methods: {
    getNameFromBeneficiaries() {
      let beneName = "BENEFICIARY NOT SET";

      if (Object.keys(this.beneficiaries).length > 0) {
        beneName = this.beneficiaries[0].name;
      }

      return beneName;
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      beneficiaries: "lead/beneficiaries",
    }),
  },
};
</script>

<style lang="scss">
.script-agent {
  max-height: 400px;
  overflow: auto;
  &__title {
    text-align: center;
  }
  &__section {
    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 20px 0;
    }
  }
  &__question {
    border-left: 3px solid red;
    padding-left: 10px;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    &-span {
      cursor: pointer;
      color: red;
    }
    .yes-text {
      text-decoration: underline;
      text-decoration-color: red;
    }
    p {
      display: flex;
      align-items: center;
      margin: 0;
    }
  }
  &__input {
    max-width: 200px;
    margin-right: 20px;
  }
}
</style>